import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { RUNTIME_NAMESPACES } from "./namespaces";

// Порядок ключей задаёт порядок в выпадающем списке выбора языка
// (LanguageSwitcher итерирует Object.entries). Целевой рынок — EU/US,
// поэтому English первым, русский — последним.
export const supportedLanguages = {
  en: { name: "English", flag: "🇬🇧" },
  de: { name: "Deutsch", flag: "🇩🇪" },
  fr: { name: "Français", flag: "🇫🇷" },
  es: { name: "Español", flag: "🇪🇸" },
  ru: { name: "Русский", flag: "🇷🇺" },
} as const;

export type SupportedLanguage = keyof typeof supportedLanguages;

export const defaultNS = "common";
export const fallbackLng = "en";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS,
    fallbackLng,
    supportedLngs: ["en", "ru", "de", "fr", "es"],
    ns: [...RUNTIME_NAMESPACES],
    pluralSeparator: "_",

    backend: {
      // Translations are served from public/locales/{lng}/{ns}.json
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    interpolation: {
      escapeValue: false,
    },
    returnObjects: true,
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },

    // Show keys while translations load — avoids blank flash
    saveMissing: false,
    missingKeyHandler: false,
  });

export default i18n;
